export default __webpack_public_path__ + "static/media/spin-webconfirm.60c274e1.svg";